import styled from "styled-components";
import { ButtonContainerProps } from "./Button.types";
import { colors } from "../../../utils/styled/_variables.styled";

export const ButtonContainer = styled.button<ButtonContainerProps>`
    min-height: 48px;
    width: fit-content;
    padding: 12px 24px;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border: ${(props) => props.$type === 'outline' ? `1px solid ${props.$backgroundColor}` : 'unset'};
    background: ${(props) => props.$type === 'default' ? props.$backgroundColor : 'transparent'};
    
    span {
        font-size: 16px;
        font-weight: 600;
        color: ${(props) => props.$fontColor || colors.white};
    }

    .loader {
      width: 24px;
      aspect-ratio: 1;
      border-radius: 50%;
      border: 2px solid ${colors.greenDark};
      padding: 2px;
      animation:
        l20-1 0.8s infinite linear alternate,
        l20-2 1.6s infinite linear;
    }
    @keyframes l20-1{
      0%    {clip-path: polygon(50% 50%,0       0,  50%   0%,  50%    0%, 50%    0%, 50%    0%, 50%    0% )}
      12.5% {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100%   0%, 100%   0%, 100%   0% )}
      25%   {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100% 100%, 100% 100%, 100% 100% )}
      50%   {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100% 100%, 50%  100%, 0%   100% )}
      62.5% {clip-path: polygon(50% 50%,100%    0, 100%   0%,  100%   0%, 100% 100%, 50%  100%, 0%   100% )}
      75%   {clip-path: polygon(50% 50%,100% 100%, 100% 100%,  100% 100%, 100% 100%, 50%  100%, 0%   100% )}
      100%  {clip-path: polygon(50% 50%,50%  100%,  50% 100%,   50% 100%,  50% 100%, 50%  100%, 0%   100% )}
    }
    @keyframes l20-2{ 
      0%    {transform:scaleY(1)  rotate(0deg)}
      49.99%{transform:scaleY(1)  rotate(135deg)}
      50%   {transform:scaleY(-1) rotate(0deg)}
      100%  {transform:scaleY(-1) rotate(-135deg)}
    }
`;
